import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["teamId", "limit", "search", "offset", "ids", "includeDeletedUsers", "filterForAdminRole"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useInfiniteQuery } from 'react-query';
import api from 'utils/api';
import usersKeys from './queryKeys';
import { DEFAULT_ITEMS_PER_PAGE } from 'utils/pagination';
function useFetchUsers(_ref) {
  var _data$pages;
  var teamId = _ref.teamId,
    limit = _ref.limit,
    search = _ref.search,
    offset = _ref.offset,
    ids = _ref.ids,
    includeDeletedUsers = _ref.includeDeletedUsers,
    filterForAdminRole = _ref.filterForAdminRole,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  var queryKey = usersKeys.usersQuery({
    limit: limit,
    search: search,
    offset: offset,
    ids: ids,
    teamId: teamId,
    includeDeletedUsers: includeDeletedUsers,
    filterForAdminRole: filterForAdminRole
  });
  function queryFn(_x) {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var pageParam, _yield$api, items, nextOffset;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pageParam = _ref2.pageParam;
            if (!(pageParam === false)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", {});
          case 3:
            _context.next = 5;
            return api('get', '/api/users', {
              limit: limit || DEFAULT_ITEMS_PER_PAGE,
              offset: offset || pageParam || 0,
              search: search,
              ids: ids,
              teamId: teamId,
              includeDeletedUsers: includeDeletedUsers,
              filterForAdminRole: filterForAdminRole
            });
          case 5:
            _yield$api = _context.sent;
            items = _yield$api.items;
            nextOffset = _yield$api.nextOffset;
            return _context.abrupt("return", {
              items: items,
              nextOffset: nextOffset
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var _useInfiniteQuery = useInfiniteQuery(queryKey, queryFn, _objectSpread(_objectSpread({}, queryOptions), {}, {
      getNextPageParam: function getNextPageParam(lastPage) {
        return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.nextOffset) || false;
      },
      staleTime: 5 * 60 * 1000 // 5 minutes
    })),
    data = _useInfiniteQuery.data,
    result = _objectWithoutProperties(_useInfiniteQuery, _excluded2);
  var items = (data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.filter(function (page) {
    return page.items;
  }).flatMap(function (page) {
    return page.items;
  })) || [];
  return _objectSpread({
    items: items
  }, result);
}
export default useFetchUsers;